<template>
<div  style="padding:20px;">
<van-icon :name="showIcon" size="120" color="#1989fa"/>
<div style="margin-bottom:50px;margin-top:50px;">
打印机设置地址：<a style="color:black" :href='showContent'>{{showContent}}</a>
</div>
<van-cell-group>
  <van-button type="info" size="large" @click="scanCode" >重新获取</van-button>
</van-cell-group>
<van-cell-group  v-show="showText">
   <van-cell border=false>
   <div>请访问此地址进行打印机设置，访问地址时需确保访问设备与E精灵处于同一局域网络环境下。（建议使用电脑访问以上地址）</div>
   </van-cell>
</van-cell-group>
<van-loading  v-show="showLoad" color="#1989fa"/>
</div>
</template>
<script>
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';
import { Button } from 'vant';
import { Toast } from 'vant';
import { Icon } from 'vant';
import { Loading } from 'vant';

Vue.use(Loading);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
		name: 'RegDataGet',
		data() {
			return {
        showContent: "",
        showIcon:"passed",
        showText:false,
        showLoad:false
      }
		},methods:{
      
      scanCode(){

    this.showLoad=true;
 
    var that=this;
     // 传统写法
     this.$http.post('/shwjw/pie/regsterData?pieId='+that.request("id"),[]).then(function(response){

        if(response.data.success){

           that.showContent="http://"+response.data.areaip+":631/"

           that.showText=true;

           that.showLoad=false;

        }else{

            that.showIcon="close";
            that.showContent="未获取到E精灵注册信息，请尝试重新获取";
            that.showText=false;
              that.showLoad=false;

        }

     }, function(response){
   
          that.showIcon="close";
          that.showContent="未获取到E精灵注册信息，请尝试重新获取";
          that.showText=false;
          that.showLoad=false;

    });

        },request(name) {
    var reg = new RegExp("(\\?|\&)" + name + "=([^&]*)(\&|$)", "i");
    var r = window.location.href.match(reg);
    if (r != null) return unescape(r[2]); return null;
    }

    },mounted(){
      this.scanCode();
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/RegDataGet.vue